import React from 'react';
import { usePriceFormatter, useShowContextRequired } from 'ui-builder';
import { Project, ProjectDetailsField } from 'nekst-api';
import { UpdateFieldWrapper } from "./UpdateFieldWrapper";

export default function PriceDetailsField(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  props: {
    field: ProjectDetailsField,
  },
) {
  const showContext = useShowContextRequired<Project>();

  const priceFormatter = usePriceFormatter();

  const data = showContext.data;

  const details = data.statistic!.details;

  const price = details
    .find((d) => d.setting.id === props.field.id)
    ?.value as number | null;


  let content;
  if (price) {
    content = (
      <span>{priceFormatter.format(price)}</span>
    );
  } else {
    content = (<>-</>);
  }

  return (
    <UpdateFieldWrapper field={props.field}>
      {content}
    </UpdateFieldWrapper>
  )
}
